import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { TranslateModule } from '@ngx-translate/core';
import { NouisliderModule } from 'ng2-nouislider';
import { DragScrollModule } from 'ngx-drag-scroll';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgxPaginationModule } from 'ngx-pagination';
import { VolvoComponents } from '~/components';
import { VolvoDirectives } from '~/core/directives';
import { MaterialModule } from '~/modules/material.module';
import { VolvoPipesModule } from './core/pipes/volvo-pipes.module';
import { InternalFilterComponent } from './modules/admin-shared/components/filter/filter.component';

import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';

@NgModule({
    declarations: [
        ...VolvoDirectives,
        ...VolvoComponents
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        NgxPaginationModule,
        FilterPipeModule,
        DragScrollModule,
        NouisliderModule,
        VolvoPipesModule,
        CarouselModule,
        InternalFilterComponent,
        RouterModule,
        LocalizeRouterModule,
        TranslateModule
        ,RecaptchaModule, RecaptchaFormsModule
    ],
    exports: [
        ...VolvoDirectives,
        ...VolvoComponents,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        NgxPaginationModule,
        FilterPipeModule,
        DragScrollModule,
        NouisliderModule,
        VolvoPipesModule,
        CarouselModule,
        InternalFilterComponent,
        RouterModule,
        LocalizeRouterModule,
        TranslateModule
        ,RecaptchaModule, RecaptchaFormsModule
    ]
})
export class AppSharedModule { }
